import { useDispatch, useSelector } from "react-redux"

import { fileActions } from "../../../../../store/files-slice"

const Pagination = (props) => {

    let dispatch = useDispatch()
    const { index, files } = props
    let selectedpagination = useSelector(state => state.file.selectedpagination)

    return <button type='button' className={`w-auto mt-3 btn ${selectedpagination == index ? 'active' : ''}`} onClick={() => {
        dispatch(fileActions.setFilteredItems(files))
        dispatch(fileActions.setSelectedPagination(index))
    }}  >{index + 1}</button>


}

export default Pagination;